export function loadExampleFile(file, callback) {
  $.ajax('examples/' + file, {dataType: 'text'}).done(function (data) {
    callback(data);
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/local-loader.js
// module id = 539
// module chunks = 0